import { render, staticRenderFns } from "./shiftChange.vue?vue&type=template&id=0fa74192&scoped=true&"
import script from "./shiftChange.vue?vue&type=script&lang=js&"
export * from "./shiftChange.vue?vue&type=script&lang=js&"
import style0 from "./shiftChange.vue?vue&type=style&index=0&id=0fa74192&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa74192",
  null
  
)

export default component.exports